<template>
    <div class="body">
        <div class="head">
            <span class="cardA">
                    <p class="cardTitle">客户人数</p>
                    <p class="cardValue">1250</p>
                    <p class="cardStatis">+1.5%同昨天对比</p>
            </span>
            <span class="cardB">
                    <p class="cardTitle">客户人数</p>
                    <p class="cardValue">1250</p>
                    <p class="cardStatis">+1.5%同昨天对比</p>
            </span>
            <span class="cardC">
                    <p class="cardTitle">客户人数</p>
                    <p class="cardValue">1250</p>
                    <p class="cardStatis">+1.5%同昨天对比</p>
            </span>
            <span class="cardD">
                    <p class="cardTitle">客户人数</p>
                    <p class="cardValue">1250</p>
                    <p class="cardStatis">+1.5%同昨天对比</p>
            </span>
        </div>

        <div class="content">
            <div class="draw">
                <span class="drawTitle">实付金额</span>
                <span class="drawButtom">
                    <span>7天</span>
                     <span>15天</span>
                      <span>30天</span>
                </span>
                <ve-line :data="chartData" :settings="chartSettings"></ve-line>

            </div>
            <div class="sort">
                <p class="sortName">销售排行榜</p>
                <p class="staffTitle">
                    <span class="sortNum">排行</span>
                    <span class="staffInfo">员工信息</span>
                    <span class="staffNum">成交单数</span>
                </p>
                <p class="staffList">
                    <span class="sortNum">
                            <img class="logoImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/gold.png">
                    </span>
                    <span class="staffInfo">
                        <span class="staffImg"><img class="logoImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/customLogin.png"></span>
                        <span class="staffIn">
                            <p>张一</p>
                            <p>工号:123456</p>
                        </span>
                    </span>
                    <span class="staffNum">12</span>
                </p>
                <p  class="staffList">
                    <span class="sortNum">
                           <img class="logoImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/silver.png">
                    </span>
                    <span class="staffInfo">
                        <span class="staffImg"><img class="logoImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/customLogin.png"></span>
                        <span class="staffIn">
                            <p>张一</p>
                            <p>工号:123456</p>
                        </span>
                    </span> 
                    <span class="staffNum">12</span>
                </p>
                <p  class="staffList">
                    <span class="sortNum">
                           <img class="logoImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/copper.png">
                    </span>
                    <span class="staffInfo">
                        <span class="staffImg"><img class="logoImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/customLogin.png"></span>
                        <span class="staffIn">
                            <p>张一</p>
                            <p>工号:123456</p>
                        </span>
                    </span>
                    <span class="staffNum">12</span>
                </p>
            </div> 
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      this.chartSettings = {
        stack: { '用户': ['访问用户', '下单用户'] },
        area: true
      }
      return {
        chartData: {
          columns: ['day', '访问用户', '下单用户', '下单率'],
          rows: [
            { 'day': '1/1', '访问用户': 1393, '下单用户': 1093, '下单率': 0.32 },
            { 'day': '1/2', '访问用户': 3530, '下单用户': 3230, '下单率': 0.26 },
            { 'day': '1/3', '访问用户': 2923, '下单用户': 2623, '下单率': 0.76 },
            { 'day': '1/4', '访问用户': 1723, '下单用户': 1423, '下单率': 0.49 },
            { 'day': '1/5', '访问用户': 3792, '下单用户': 3492, '下单率': 0.323 },
            { 'day': '1/6', '访问用户': 4593, '下单用户': 4293, '下单率': 0.78 }
          ]
        }
      }
    }
  }
</script>


<style scoped>
.body{
    background-color: #EFF1F3;
}
.head{
    background-color:#EFF1F3;
    margin-top: 1%;
    height: 10%;
}
.cardA{
    display: inline-block;
    width: 20%;
    height: 120px;
    border-radius: 10px;
    background: linear-gradient(to right,#FF915A,#FF9D6A,#FFA97B,#FDB18B);
    font-size: 20px;
    color: #FFFFff;
}
.cardB{
    display: inline-block;
    width: 20%;
    height: 120px;
    margin-left: 4%;
    border-radius: 10px;
    background: linear-gradient(to right,#E86279,#F57590,#F987A4,#F892B3);
    font-size: 20px;
    color: #FFFFff;
}
.cardC{
    display: inline-block;
    width: 20%;
    height: 120px;
    margin-left: 4%;
    border-radius: 10px;
    background: linear-gradient(to right,#3B86FA,#5193F5,#6CACFB,#89C4FF);
    font-size: 20px;
    color: #FFFFff;
}
.cardD{
    display: inline-block;
    width: 20%;
    height: 120px;
    margin-left: 4%;
    border-radius: 10px;
    background: linear-gradient(to right,#C18BF8,#D493F9,#E39CFF,#EDA3FF);
    font-size: 20px;
    color: #FFFFff;
}
.cardTitle{
    line-height: 40px;
    text-align: left;
    margin-left: 5%;
}
.cardValue{
    line-height: 40px;
    text-align: left;
    margin-left: 5%;
}
.cardStatis{
    line-height: 40px;
    text-align: left;
    margin-left: 5%;
}
.content{
    /* background-color:aqua; */
    margin-top: 5%;
    height: 75%;
    width: 100%;
    /* margin-left: 5%; */
}
.draw{
    background-color: #FFFFff;
    width: 68%;
    float: left;
    border-radius: 10px;
    height: 90%;
    margin-left: 4%;
}
.sort{
    background-color: #FFFFff;
    float: left;
    width: 20%;
    height: 90%;
    margin-left: 4.5%;
    border-radius: 10px;
}
.drawTitle{
    display: inline-block;
    width: 45%;
    /* background-color: #FDB18B; */
    line-height: 60px;
    text-align: left;
    font-size: 18px;
}
.drawButtom{
    display: inline-block;
    width: 45%;
    /* background-color: aqua; */
    line-height: 60px;
    font-size: 18px;
    text-align: right;
}
.sortName{
    font-size: 20px;
    margin-top: 5%;
    font-weight: 600;
    margin-bottom: 5%;
}
.staffTitle{
    margin-bottom: 5%;
    color: #97999B;
}
.sortNum{
    display: inline-block;
    width: 20%;
}
.staffInfo{
    display: inline-block;
    width: 50%;
    /* background-color: #FDB18B; */
}
.staffNum{
    display: inline-block;
    width: 20%;
    font-weight: 600;
}
.staffImg{
    display: inline-block;
    width: 30%;
    vertical-align:middle;
    /* background-color: aqua; */
}
.staffIn{
    display: inline-block;
    width: 60%;
    text-align: left;
    /* background-color: blue; */
    vertical-align:middle;
}
.logoImg{
    width: 30px;
    height: 30px;
    vertical-align:middle;
}
.staffList{
    font-size: 15px;
    margin-top: 1%;
}
</style>


// WEBPACK FOOTER //
// src/components/DataStatis/dataStatis.vue